import { Button } from '@dixa/lib-shared-habla';
import { FunctionComponent } from 'react';

interface SatisfactionDisabledButtonProps {
  text: string;
}

export const SatisfactionDisabledButton: FunctionComponent<
  SatisfactionDisabledButtonProps
> = ({ text, ...otherProps }) => (
  <Button {...otherProps} disabled>
    {text}
  </Button>
);
